'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.core').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('en-US', {
            'common': {
                'download-button': {
                    'Download': 'Download',
                    'CSV file': 'CSV file',
                    'Image': 'Image',
                    'Vector image': 'Vector image'
                }
            }
        });
    }
})();